module.exports = __webpack_public_path__ + "static/media/delivery-icon2.76d0d52c.png";